import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Button, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import {
  PlansCounterChip,
  SectionAccordion,
  SectionAccordionDetails,
  SectionAccordionSummary,
  SectionSummaryContent,
  SectionSummaryTitle,
  SectionWrapper,
} from 'src/pages/Settings/memberships/components/plans-tab/styled';

const addFeatureButtonSx = {
  alignSelf: 'flex-start',
  textTransform: 'none',
  fontWeight: 500,
} as const;

type FeaturesSectionProps = {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  count: number;
  onAddFeature: () => void;
  readOnly: boolean;
  children?: ReactNode;
};

export const FeaturesSection = ({
  expanded,
  onExpandedChange,
  count,
  onAddFeature,
  readOnly,
  children,
}: FeaturesSectionProps) => {
  return (
    <SectionWrapper data-testid="features-section">
      <SectionAccordion
        elevation={0}
        expanded={expanded}
        TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
        onChange={(_, expandedValue) => {
          onExpandedChange(expandedValue);
        }}
        disableGutters
      >
        <SectionAccordionSummary expandIcon={<ChevronRightIcon />}>
          <SectionSummaryContent>
            <SectionSummaryTitle variant="h6">Features</SectionSummaryTitle>
            <PlansCounterChip label={`${count}`} size="small" />
          </SectionSummaryContent>
        </SectionAccordionSummary>

        <SectionAccordionDetails>
          {expanded ? (
            <Stack gap={1.5} pt={1}>
              {children}
              {!readOnly ? (
                <Button
                  startIcon={<AddIcon />}
                  variant="text"
                  onClick={onAddFeature}
                  sx={addFeatureButtonSx}
                >
                  Add feature
                </Button>
              ) : null}
            </Stack>
          ) : null}
        </SectionAccordionDetails>
      </SectionAccordion>
    </SectionWrapper>
  );
};
